import { createApp } from "vue";

import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import { Amplify } from "aws-amplify";
import VueApexCharts from "vue3-apexcharts";

loadFonts();

Amplify.configure({
  Auth: {
    Cognito: {
      region: "ap-southeast-1",
      userPoolId: "ap-southeast-1_bjqVgmylE",
      userPoolClientId: "5vhndptavr8cun4hqpobq4ln26",
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    GraphQL: {
      endpoint:
        "https://b523hkow2jhy3gw5tujqmnhxgu.appsync-api.ap-southeast-1.amazonaws.com/graphql",
      region: "ap-southeast-1",
      defaultAuthMode: "apiKey",
      apiKey: "da2-wlrjxcpttffstltqka5dfrwtgi",
      logger_level: "DEBUG",
    },
  },
});

const app = createApp(App);

app.use(store);
app.use(router);
app.use(vuetify);
app.use(VueApexCharts);

app.mount("#app");
